export const environment = {
  production: false,
  featureScope: "PREVIEW",
  keycloakBaseUrl: 'https://sso.dev.services.utimaco.com',
  keycloakRealm: 'Utimaco-Portal-DEV',
  keycloakClientId: 'TaasPortalFrontend',
  //    restApiBasePath: 'http://localhost/api/v1/',
  restApiBasePath: 'https://portal-api.dev.services.utimaco.com/api/v1/',
  dmsUrl: 'https://dms.dev.services.utimaco.com',
  marketplaceUrl: 'https://marketplace.dev.services.utimaco.com',
  frontendUrls: [
    {
      productTypes: ['General Purpose HSM as a Service', 'Payment HSM as a Service'],
      frontendUrl: 'https://dev.portal.myhsm.com/'
    },
    {
      productTypes: ['EKM as a Service'],
      frontendUrl: 'https://ekmaas.dev.services.utimaco.com/'
    },
    {
      productTypes: ['Timestamp as a Service'],
      frontendUrl: 'https://timestamp.dev.services.utimaco.com/'
    },
    {
      productTypes: ['File and Folder Encryption as a Service'],
      frontendUrl: 'https://portal.lancrypt.com/'
    },
    {
      productTypes: ['eInvoice Signature as a Service'],
      //TODO add URL once provided in TUP-169
      frontendUrl: ''
    },
    {
      productTypes: ['POS Key Generation aaS'],
      //TODO add URL once provided in TUP-169
      frontendUrl: ''
    },
  ]
};